import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import SaveForLaterButton from './components/saveForLaterButton/SaveForLaterButtonComponent';
import SaveForLaterModal from './components/saveForLaterModal/SaveForLaterModal';
import executeTrackingEvent from 'managers/gtmEventTracking/executeTrackingEvent';
import { CLICKED_SHARE_BUTTON } from 'managers/gtmEventTracking/constants/eventsNames';
import { isMobile as getIsMobile } from 'utils/isMobile';
import queryString from 'query-string';

class SaveForLater extends Component {
  constructor(props) {
    super(props);

    this.state = {
      url: null,
      modalOpen: false,
    };

    this.handleOnClickSaveForLater = this.handleOnClickSaveForLater.bind(this);
    this.handleOnClickCloseSaveForLaterModal = this.handleOnClickCloseSaveForLaterModal.bind(this);
  }

  async handleOnClickSaveForLater() {
    const { executeTrackingEvent, abandonedCartUuid } = this.props;
    executeTrackingEvent(CLICKED_SHARE_BUTTON);

    const url = getSaveForLaterUrl(abandonedCartUuid);
    this.setState({ url });

    const isMobile = getIsMobile();

    if (navigator.share && isMobile) {
      try {
        const shareData = {
          url: url,
        };
        await navigator.share(shareData);
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      this.setState({ modalOpen: true });
    }
  }

  handleOnClickCloseSaveForLaterModal() {
    this.setState({ modalOpen: false });
  }

  render() {
    const { modalOpen, url } = this.state;
    const { isCheckoutPage, airlineWhitelabel } = this.props;

    if (!isCheckoutPage) {
      return null;
    }

    return (
      <Fragment>
        <SaveForLaterButton
          onClickSaveForLater={this.handleOnClickSaveForLater}
          airlineWhitelabel={airlineWhitelabel}
        />
        <SaveForLaterModal modalOpen={modalOpen} onClickClose={this.handleOnClickCloseSaveForLaterModal} url={url} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isCheckoutPage: state.currentPageComponent.isCheckoutPage,
    airlineWhitelabel: state.settings.value.airlineWhitelabel,
    abandonedCartUuid: state.checkoutPageAbandonedCart.uuid,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    executeTrackingEvent(eventName, eventData) {
      dispatch(executeTrackingEvent(eventName, eventData));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SaveForLater);

function getSaveForLaterUrl(abandonedCartUuid) {
  let queryParameters = queryString.parse(window.location.search);
  queryParameters.abandonedCartBlob = abandonedCartUuid;
  const searchQuery = queryString.stringify(queryParameters);

  return `${window.location.origin}${window.location.pathname}?${searchQuery}`;
}
